import { IEquatable } from "../Utils/ObjUtils";
import { HashSet } from "../Utils/HashSet";
import { IpAddress } from "./IpAddress";

export class IpRange implements IEquatable {
	private _min: IpAddress;
	public get Min(): IpAddress {
		return this._min;
	}

	private _max: IpAddress;
	public get Max(): IpAddress {
		return this._max;
	}

	public static Create(min: IpAddress, max: IpAddress): IpRange {
		if (!min || !max || min.IpVersion != max.IpVersion || min.CompareTo(max) > 0)
			return null;
		else
			return new IpRange(min, max);
	}

	public static CreateFromString(rangeStr: string) :IpRange {
		if (!rangeStr)
			return null;

		var dashIdx = rangeStr.indexOf('-');
		if (dashIdx < 0)
			return null;

		var minIpStr = rangeStr.substring(0, dashIdx).trim();
		if (!minIpStr)
			return null;

		var maxIpStr = rangeStr.substring(dashIdx + 1).trim();
		if (!maxIpStr)
			return null;

		var minIp = IpAddress.Create(minIpStr);
		var maxIp = IpAddress.Create(maxIpStr);

		return IpRange.Create(minIp, maxIp);
	}

	constructor(min: IpAddress, max:IpAddress ) {
		this._min = min;
		this._max = max;
	}

	public Clone() : IpRange  {
		var clonedRange = new IpRange(this.Min.Clone(),this.Max.Clone());
		return clonedRange;
	}

	public Contains(ip: IpAddress) : boolean {
		return this.Min.CompareTo(ip) <= 0 && ip.CompareTo(this.Max) <= 0;
	}

	public toString(): string {
		return this.Min.toString() + " - " + this.Max.toString();
	}

	public ToString(): string {
		return this.toString();
	}

	public get IpAddresses() : HashSet<IpAddress> {
		var ipAddresses = new HashSet<IpAddress>();

		var minIp = this.Min.Clone();
		var maxIp = this.Max.Clone();

		if ((minIp != null) && (maxIp != null)) {
			var nextIp = minIp;

			while (nextIp.CompareTo(maxIp) <= 0) {
				ipAddresses.Add(nextIp.Clone());
				nextIp.Increment();
			}
		}

		return (ipAddresses);
	}

	public Equals(obj: any): boolean {
		if (obj == null)
			return false;

		if (obj === this)
			return true;

		if (!(obj instanceof IpRange))
			return false;

		var other = <IpRange> obj;
		return (this.Min.Equals(other.Min) && this.Max.Equals(other.Max));
	}

	public GetHashCode() : number {
		return (this.Min.GetHashCode() * this.Max.GetHashCode());
	}
}
